import React from 'react'
import { Contributions, GroupPlanType } from 'Utilities/Plans/ContributionCalculator'
import { TieredRates } from 'Utilities/pharaoh.types'
import { Label } from 'Utilities/config'
import styles from './index.module.scss'
import SupplementalPlan from 'Components/Plans/SupplementalPlan/index.helpers'
import Plan, { PlanBody } from 'Components/Plans/plan-subcomponents/Plan'
import PlanTitle from 'Components/Plans/plan-subcomponents/PlanTitle'
import { Member } from 'Utilities/Hooks/useStargate'
import EETierRate from './EESupplementalSubComp/EETierRate'
import BenefitComp from './EESupplementalSubComp/BenefitComp'
import numeral from 'numeral'
import BenefitAmountContainer from './EESupplementalSubComp/BenefitAmountContainer'
import benefitStyle from './EESupplementalSubComp/EESupplementalSubComp.module.scss'
import { GlobalStringConstant } from 'GlobalStringConstant'
import { PremiumSplits } from 'Components/Plans/plan-subcomponents/Plan.helpers'
import LifePlan, { LifeEEPlan, LifeERPlan } from '../LifePlan/index.helpers'

interface Props {
  plan: { rate: TieredRates, plan: SupplementalPlan | LifePlan | LifeEEPlan | LifeERPlan, isRenewal: boolean }
  contributions: Contributions
  selected?: boolean
  label: Label
  selectHandler?(plan: SupplementalPlan | LifePlan | LifeEEPlan | LifeERPlan): void
  showWeeklyPayments: boolean
  premium?: PremiumSplits
  member: Member
}

const ABCLifePlanEE: React.FC<Props> = ({ plan, selected, label, selectHandler, contributions, showWeeklyPayments, member }) => {
  const sbc = plan.plan.data.sbc

  return <Plan selected={!!selected}>
    <PlanTitle
      id={plan.plan.id}
      planName={plan.plan.name}
      carrier= {plan.plan.carrier}
      selected={selected}
      includesProsperBenefits={false}
      planType={GroupPlanType.life}
      label={label}
      sbc={sbc}
      selectHandler={selectHandler && (() => selectHandler(plan.plan))}
    />
    <PlanBody noWrap={true}>
      <EETierRate
        plan={plan}
        contributions={contributions}
        showWeeklyPayments={showWeeklyPayments}
        member={member}
        showAfterEmpCont={true}
        onlyIndividual={true}
      />
      <BenefitComp amountLabel=' ' name={GlobalStringConstant[0].benefit_amount} benefitAmount={numeral(plan.plan.data.benefitsIndividual).format('0,0')}/>
      <div className={styles.vertContainer}>
        <BenefitAmountContainer>
          <div className={styles.vertFlex}>
            <div className={benefitStyle.benefitBoxTitle}>{GlobalStringConstant[0].supp_ad_and_d_inc}</div>
            <div className={`${benefitStyle.accidental_death_price} ${benefitStyle.hospital_benifit_amount}`}>
              <span className={benefitStyle.amount}><span className={benefitStyle.dolar}>{GlobalStringConstant[0].dolar}</span>10,000</span>
            </div>
          </div>
        </BenefitAmountContainer>
        <BenefitAmountContainer>
          <div className={styles.vertFlex}>
            <div className={benefitStyle.benefitBoxTitle}>{GlobalStringConstant[0].EAP_serv_pro}</div>
            <div className={`${benefitStyle.accidental_death_price} ${benefitStyle.hospital_benifit_amount}`}>
              <span className={benefitStyle.portability_text}>{GlobalStringConstant[0].will_prep}</span>
            </div>
          </div>
        </BenefitAmountContainer>
      </div>
    </PlanBody>
  </Plan>
}

export default ABCLifePlanEE
